import React from "react";
import { Box, Typography, IconButton, CircularProgress } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import SingleCard from "../AdsPage/SingleCard";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { fonts, headingFonts, noOutline } from "../../Styles/Styles";
import LoadingAnimation from "../Animations/LoadingAnimation";
import CardSkeleton from "../AdsPage/CardSkeleton";

const AdsSlider = ({
  ads,
  isLoading, // Added loading prop
  error, // Added error prop
  sectionTitle,
  sectionSubTitle,
  prevClass,
  nextClass,
  category, // Added category prop to filter ads
}) => {
  // Filter ads based on category if provided
  const filteredAds = category
    ? ads.filter((ad) => ad.category === category) // Assuming ad.category holds the category label
    : ads;

  // Limit to 10 ads per category
  const limitedAds = filteredAds.slice(0, 10);

  return (
    <Box sx={{ margin: "auto", mt: 15, mb: 15, px: 2, width: "95%" }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        {/* Left: Title Section */}
        <Box>
          <Typography
            variant="body1"
            sx={{ ...fonts, color: "text.secondary" }}
          >
            {sectionSubTitle}
          </Typography>
          <Typography
            variant="h5"
            sx={{ ...headingFonts, color: "text.primary" }}
          >
            {sectionTitle}
          </Typography>
        </Box>

        {/* Right: Navigation Arrows */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            className={prevClass}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--primary-color)",
              ...noOutline,
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <IconButton
            className={nextClass}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--primary-color)",
              ...noOutline,
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
      </Box>

      {/* Error State */}
      {error && (
        <Typography
          variant="body2"
          sx={{ ...fonts, textAlign: "center", color: "red", my: 2 }}
        >
          {error}
        </Typography>
      )}

      {/* No Ads Found */}
      {!isLoading && !error && limitedAds.length === 0 && (
        <Typography
          variant="body2"
          sx={{ ...fonts, textAlign: "center", color: "text.secondary", my: 2 }}
        >
          No ads available.
        </Typography>
      )}

      {/* Loading State */}
      {/* {isLoading && <LoadingAnimation />} */}
      <Swiper
        spaceBetween={16} // gap between slides
        slidesPerView={5} // show 5 slides at once
      >
        {isLoading &&
          Array.from({ length: 5 }).map((_, index) => (
            <SwiperSlide key={index}>
              <CardSkeleton />
            </SwiperSlide>
          ))}
      </Swiper>
      {/* Swiper Component (Only Render if Ads Exist) */}
      {!isLoading && !error && limitedAds.length > 0 && (
        <Swiper
          modules={[Navigation]}
          spaceBetween={25}
          slidesPerView={5}
          navigation={{ prevEl: `.${prevClass}`, nextEl: `.${nextClass}` }}
          breakpoints={{
            1200: {
              slidesPerView: 5,
            },
            900: {
              slidesPerView: 4,
            },
            600: {
              slidesPerView: 3,
            },
            0: {
              slidesPerView: 1,
            },
          }}
        >
          {limitedAds.map((slide) => (
            <SwiperSlide key={slide.id}>
              <SingleCard AdInfo={slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </Box>
  );
};

export default AdsSlider;
